import React from "react";
import SectionTabs from "../../../components/SectionTabs/SectionTabs";

const tabs = [
  { to: "/admin/products", label: "Products", end: true },
  { to: "/admin/products/categories", label: "Categories" },
];

const ProductsNav = () => <SectionTabs tabs={tabs} />;

export default ProductsNav;
